import React from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import AutomationActivityFeed from '../../components/AutomationActivityFeed/AutomationActivityFeed';

const ManagerActivityFeedView: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        sx={{ mb: 3, gap: 1.5 }}
      >
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Automation Activity Feed
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Every automated email, text message, portal update, and Outlook draft across all cases and leads.
          </Typography>
        </Box>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" size="small" component={Link} to="/">
            Main Home
          </Button>
          <Button
            variant="outlined"
            size="small"
            component={Link}
            to="/intake-home"
          >
            Intake Home
          </Button>
        </Stack>
      </Stack>

      <AutomationActivityFeed pageSize={75} />
    </Container>
  );
};

export default ManagerActivityFeedView;
